import UltMeta, { Meta } from "@/meta/UltMeta/index";

// 装载状态
class RecognizeResult extends UltMeta {
    LOADING = new Meta(0, "装载中");
    UNLOADING = new Meta(1, "卸货中");
    LOADED = new Meta(2, "满载");
    IDLE = new Meta(3, "空载");
    UNKNOWN = new Meta(4, "未知");
}
export const RECOGNIZE_RESULT = new RecognizeResult();

// 模型数据-标签
class ModelLabel extends UltMeta {
    IDLE = new Meta(2, "空载");
    LOADED = new Meta(1, "满载");
    LOADING = new Meta(3, "装载中");
    UNLOADING = new Meta(4, "卸货中");
    UNKNOWN = new Meta(5, "未知");
}

export const MODEL_LABEL = new ModelLabel();

// 模型数据-标记状态
class ModelTagStatus extends UltMeta {
    UNLABELED = new Meta(1, "未标记");
    LABELED = new Meta(2, "已标记");
    PUBLISHED = new Meta(3, "已发布");
}
export const MODEL_TAG_STATUS = new ModelTagStatus();

// 识别记录-是否加到模型
class RecordAddToModelStatus extends UltMeta {
    UNLABELED = new Meta(1, "未加入");
    LABELED = new Meta(2, "已加入");
}

export const RECORD_ADD_TO_MODEL_STATUS = new RecordAddToModelStatus();
